import { Component } from '@angular/core';

@Component({
  selector: 'app-servicehotel-form',
  templateUrl: './servicehotel-form.component.html',
  styleUrls: ['./servicehotel-form.component.css']
})
export class ServicehotelFormComponent {

}
